import React from 'react';
import classNames from 'classnames';

import {Dialog, Disclosure, Transition} from '@headlessui/react';
import {ThemeIcon, useChapters, useCurrentChapter, useAdditionalSeedData} from 'pageflow-scrolled/frontend';
import {useUserData} from './useUserData';

import {UserIcon, UserOnlineIcon} from './icons';

import styles from './MobileMenu.module.css';
import transitionStyles from './transitions.module.css';

export function MobileMenu({open, close}) {
  const chapters = useChapters();
  const currentChapter = useCurrentChapter();

  const {
    loginUrl,
    logoutUrl,
    profileUrl
  } = useAdditionalSeedData('handelsblatt');

  const user = useUserData();

  function renderSubscriptionSection() {
    if (user) {
      return (
        <div className={styles.section}>
          <Disclosure defaultOpen={true}>
            {({open}) => (
              <>
                <Disclosure.Button className={classNames(styles.disclosureButton,
                                                         {[styles.open]: open})}>
                  <UserOnlineIcon />
                  <div>
                    {user.displayName}
                  </div>
                  <ThemeIcon name="arrowRight" width={24} height={24}/>
                </Disclosure.Button>
                <Disclosure.Panel>
                  <ul className={styles.subscriptionLinks}>
                    <li>
                      <a href={profileUrl}>
                        Konto verwalten
                      </a>
                    </li>
                    <li>
                      <a href={logoutUrl}>
                        Abmelden
                      </a>
                    </li>
                  </ul>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      );
    }
    else {
      return (
        <div className={styles.section}>
          <a href="https://abo.handelsblatt.com"
             className={styles.subscribe}>Handelsblatt Abo</a>
          <ul className={styles.subscriptionLinks}>
            <li>
              <a href={loginUrl}>
                <UserIcon />
                Anmelden
              </a>
            </li>
          </ul>
        </div>
      );
    }
  }

  function renderChaptersSection() {
    if (chapters.length < 1) {
      return null;
    }

    return (
      <div className={styles.section}>
        <nav>
          <Disclosure defaultOpen={true}>
            {({open}) => (
              <>
                <Disclosure.Button className={classNames(styles.disclosureButton,
                                                         styles.chaptersHeader,
                                                         {[styles.open]: open})}>
                  <div>Artikel Themen</div>
                  <ThemeIcon name="arrowRight" width={24} height={24}/>
                </Disclosure.Button>
                <Disclosure.Panel>
                  <ul className={styles.chapters}>
                    {chapters.map(chapter =>
                      <li key={chapter.id}>
                        <a href={`#${chapter.chapterSlug}`}
                           className={classNames({[styles.active]: currentChapter?.id === chapter.id})}
                           onClick={close}>
                          {chapter.title}
                        </a>
                      </li>
                    )}
                  </ul>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </nav>
      </div>
    );
  }

  function renderLinksSection() {
    return (
      <div className={styles.section}>
        <ul className={styles.links}>
          <li>
            <a href="https://www.handelsblatt.com/kontakt/">Kontakt</a>
          </li>
          <li>
            <a href="https://www.handelsblatt.com/impressum/">Impressum</a>
          </li>
          <li>
            <a href="https://www.handelsblatt.com/datenschutzerklaerung/?lang=de">Datenschutzerklärung</a>
          </li>
        </ul>
      </div>
    );
  }

  return (
    <Transition
      appear={true}
      show={open}
      as={React.Fragment}>
      <Dialog onClose={close}
              className={styles.dialog}>
        <Transition.Child
          enter={transitionStyles.fade}
          enterFrom={transitionStyles.fadeOut}
          enterTo={transitionStyles.fadeIn}
          leave={transitionStyles.fade}
          leaveFrom={transitionStyles.fadeIn}
          leaveTo={transitionStyles.fadeOut}>
          <Dialog.Panel className={styles.panel}>
            <button className={styles.close}
                    title="Schließen"
                    onClick={close}>
              <ThemeIcon name="close" width={24} height={24}/>
            </button>
            {renderSubscriptionSection()}
            {renderChaptersSection()}
            {renderLinksSection()}
          </Dialog.Panel>
        </Transition.Child>
      </Dialog>
    </Transition>
  )
}
